export function calculateMonthlyPayment({loanAmount, monthlyRate, paymentCount}: {loanAmount: number, monthlyRate: number, paymentCount: number}) {
  // M = P[r(1+r)^n/((1+r)^n)-1)]
  // P = loan amount
  // r = monthly interest rate (annual rate / 12)
  // n = number of payments (years * 12)
  let totalInterestRate = Math.pow(1 + monthlyRate, paymentCount)
  return loanAmount * ((monthlyRate * totalInterestRate) / (totalInterestRate - 1))
}